var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18.563,
    viewBox: "0 0 22 18.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3105",
    "data-name": "Groupe 3105",
    transform: "translate(578 -1198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_999",
    "data-name": "Trac\\xE9 999",
    d: "M-533.064,1230.424h0l-1.842,1.842-.915-.915,0,0a.687.687,0,0,0-.972,0,.687.687,0,0,0,0,.972h0l1.406,1.405a.687.687,0,0,0,.972,0l2.326-2.327,0,0a.688.688,0,0,0,0-.972A.688.688,0,0,0-533.064,1230.424Z",
    transform: "translate(-26.906 -21.146)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1000",
    "data-name": "Trac\\xE9 1000",
    d: "M-558.062,1206.776v-6.713a2.065,2.065,0,0,0-2.062-2.062h-15.812a2.065,2.065,0,0,0-2.062,2.063v9.625a2.065,2.065,0,0,0,2.063,2.063h8.985a5.5,5.5,0,0,0,5.452,4.813,5.506,5.506,0,0,0,5.5-5.5A5.491,5.491,0,0,0-558.062,1206.776Zm-2.412-7.4-7.445,5.909a.239.239,0,0,1-.222,0l-7.446-5.909Zm-16.15,10.313v-9.38l7.628,6.054a1.555,1.555,0,0,0,.966.328,1.555,1.555,0,0,0,.966-.328l7.628-6.054v5.661a5.464,5.464,0,0,0-2.062-.4,5.5,5.5,0,0,0-5.452,4.813h-8.985A.688.688,0,0,1-576.625,1209.688Zm15.125,5.5a4.13,4.13,0,0,1-4.125-4.125,4.13,4.13,0,0,1,4.125-4.125,4.13,4.13,0,0,1,4.125,4.125A4.13,4.13,0,0,1-561.5,1215.188Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.5bc42ec89a49bd2db46a4eeb91c7cfb8.svg";
export { ForwardRef as ReactComponent };